import React from "react";

import {GeoJsonIlotApi,} from "./generated/api";


import {axiosInstance, config, serverUrl} from "./Utils";

const geoJsonIlotApi = new GeoJsonIlotApi(config, serverUrl, axiosInstance);


export default class ViewCtrl extends React.Component {

    static async getIrisData(code,callback) {
        geoJsonIlotApi.apiGet(code).then((result) => {
            callback(result.data);
        })
    }

    static async getCityData(code,callback) {
        geoJsonIlotApi.apiCityGet(code).then((result) => {
            callback(result.data);
        })
    }

    static async getIrisShape(code,callback) {
        geoJsonIlotApi.apiShapeGet(code).then((result) => {
            callback(result.data);
        })
    }

}